const { InnerBlocks } = wp.blockEditor;
import React from 'react';

const Save = ({ attributes }) => {
  const {
    hasNavigation,
    hasNavigationDesktop,
    loop,
    cardSpace,
    containerized,
    centered,
    margin,
    dots,
    slidesPerView,
    slidesPerView768,
    slidesPerView1280,
    slidesPerView1580,
    hasFakeItem,
  } = attributes;

  return (
    <section className={`SwiperGeral ${margin}`}>
      <div
        className={`SwiperGeral__content ${containerized ? 'Container' : ''}`}
      >
        <div
          className={`swiper SwiperGeral__slider ${loop ? 'hasLoop' : ''} ${
            centered ? 'isCentered' : ''
          }`}
          card-space={cardSpace}
          perview={slidesPerView}
          perview768={slidesPerView768}
          perview1280={slidesPerView1280}
          perview1580={slidesPerView1580}
        >
          <div className="swiper-wrapper">
            {hasFakeItem && <div className="fake-item transparent"></div>}
            <InnerBlocks.Content />
          </div>
        </div>

        {dots && <div class="swiper-pagination"></div>}

        {hasNavigation && (
          <div
            class={`custom-swiper-prev ${
              hasNavigationDesktop ? '' : 'navigation-disabled'
            }`}
          ></div>
        )}
        {hasNavigation && (
          <div
            class={`custom-swiper-next ${
              hasNavigationDesktop ? '' : 'navigation-disabled'
            }`}
          ></div>
        )}
      </div>
    </section>
  );
};

export default Save;
